{
  "pages": {
    "BillApprovalWizard": {
      "step": "Step",
      "of_3": "of 3",
      "when_would_you_like_the_payments": "When would you like the payments to be scheduled?",
      "select_one_of_the_options_below": "Select one of the options below:",
      "payment_scheduled_on_invoice_due_date": "Payment scheduled on invoice due date",
      "the_payments_for_the_selected_bills": "The payments for the selected bills will have their payout\n                      date set to the due date specified in the bill. If the\n                      bill due date has passed, the payout date will be set to\n                      immediately after they are approved.",
      "payment_scheduled_today": "Payment scheduled today",
      "the_payments_for_the_selected_bills_2": "The payments for the selected bills will be paid out\n                      immediately after they are approved regardless of their\n                      billing due date.",
      "payment_scheduled_on_next_cycle": "Payment scheduled on next cycle",
      "the_payments_for_the_selected_bills_3": "The payments for the selected bills will be scheduled\n                        for the next cycle based on your defined payment cycle.\n                        This is useful for recurring bills.",
      "next_cycle": "Next cycle:",
      "define_your_payment_cycle_to_align": "Define your payment cycle to align with your billing cycle.",
      "go_to_bills_settings": "Go to bills settings.",
      "cancel": "Cancel",
      "next": "Next",
      "review_and_confirm": "Review and confirm",
      "please_review_the_details_carefully_before": "Please review the details carefully before you proceed.",
      "how_to_approve_bill_payment_schedules": "How to approve bill payment schedules",
      "after_submitting_the_bill_payment_schedules": "After submitting the bill payment schedules, they need to be\n                  approved by authorised users. Users with appropriate access\n                  levels will be able to approve bills. If you wish to assign\n                  bills to specific users instead you can assign them to a\n                  specific bill. Note that if you continue with automatic\n                  assignment specific users might still be assigned to a bill\n                  depending on the billing amount thresholds configured under\n                  Bill Settings.",
      "summary": "Summary",
      "total_payments": "Total payments",
      "total_amount": "Total amount",
      "usd": "MYR",
      "payment_schedule": "Payment schedule",
      "payments_to_be_scheduled": "Payments to be scheduled",
      "bill": "bill",
      "missing_payment_method": "missing\n                    payment method",
      "bill_details": "Bill Details",
      "bill_due_date": "Bill Due Date",
      "payment_date": "Payment Date",
      "amount": "Amount",
      "pay_bill_with": "Pay bill with",
      "designated_approver": "Designated approver",
      "adjusted": "Adjusted",
      "immediate": "Immediate",
      "no_payment_method_configured": "No payment method configured",
      "payment_method_required": "Payment method required",
      "after_confirming_the_payment_method_and": "After confirming the payment method and optionally a\n                  designated approver, your bills will be submitted for\n                  approval.",
      "your_selected_payment_schedule_is": "Your selected payment schedule is",
      "unable_to_schedule_payments_please_ensure": "Unable to schedule payments. Please ensure all bills have a\n                  payment method selected.",
      "back": "Back",
      "confirm_and_schedule": "Confirm and schedule",
      "payments_scheduled_successfully": "Payments scheduled successfully",
      "been_submitted_for_approval_approvers_will": "been submitted\n              for approval. Approvers will be notified to review and approve the\n              scheduled payments.",
      "total_scheduled": "Total scheduled",
      "assigned_to_you": "Assigned to you",
      "view_under_assigned_to_me_tab": "View under \"Assigned to me\" tab",
      "autoassigned": "Auto-assigned",
      "based_on_threshold_rules": "Based on threshold rules",
      "scheduled_payments": "Scheduled payments",
      "payment_on": "· Payment on",
      "approver": "· Approver:",
      "back_to_bills": "Back to Bills"
    },
    "BillDetail": {
      "total_amount": "Total Amount",
      "issue_date": "Issue Date",
      "due_date": "Due Date",
      "approval_date": "Approval Date",
      "paid_date": "Paid Date",
      "supplier_details": "Supplier Details",
      "view_profile": "View Profile →",
      "company_name": "Company Name",
      "contact_email": "Contact Email",
      "phone_number": "Phone Number",
      "payment_information": "Payment Information",
      "funded_from": "Funded From",
      "paid_on": "Paid on",
      "paid_to": "Paid To",
      "scheduled_for_payment": "Scheduled for Payment",
      "this_bill_is_scheduled_to_be": "This bill is scheduled to be paid on or before",
      "attachment": "Attachment",
      "uploaded_with_bill": "Uploaded with bill",
      "download": "Download",
      "no_file_attached_to_this_bill": "No file attached to this bill",
      "subtotal": "Subtotal",
      "tax": "Tax",
      "discount": "Discount",
      "total": "Total",
      "notes": "Notes",
      "actions": "Actions",
      "schedule_payment": "Schedule Payment",
      "archive_bill": "Archive Bill",
      "edit_details": "Edit Details",
      "approval_required": "Approval Required",
      "this_bill_has_been_assigned_to": "This bill has been assigned to you. Please review the\n                        details and approve or reject.",
      "approve_bill": "Approve Bill",
      "reject_bill": "Reject Bill",
      "status": "Status",
      "awaiting_approval": "Awaiting Approval",
      "assigned_to": "Assigned to:",
      "payment_scheduled": "Payment Scheduled",
      "will_be_paid_on": "Will be paid on",
      "cancel_schedule": "Cancel Schedule",
      "payment_complete": "Payment Complete",
      "successfully_paid_on": "Successfully paid on",
      "bill_rejected": "Bill Rejected",
      "rejected_by": "Rejected by",
      "reason": "Reason:",
      "workflow_timeline": "Workflow Timeline",
      "awaiting": "Awaiting",
      "are_you_sure_you_want_to": "Are you sure you want to reject bill",
      "this_action_will_notify_the_submitter": "? This action will notify the submitter.",
      "reason_for_rejection": "Reason for rejection",
      "attrs": {
        "please_provide_a_reason": "Please provide a reason..."
      }
    },
    "BillFinancingWizard": {
      "back_to_bill": "Back to Bill",
      "select_provider": "Select Provider",
      "financing_terms": "Financing Terms",
      "review_submit": "Review & Submit",
      "bill_information": "Bill Information",
      "review_the_bill_details_for_financing": "Review the bill details for financing",
      "bill_number": "Bill Number",
      "supplier": "Supplier",
      "bill_amount": "Bill Amount",
      "rs": "Rs.",
      "bill_financing_benefits": "Bill Financing Benefits",
      "improve_cash_flow_by_paying_suppliers": "Improve cash flow by paying suppliers early",
      "maintain_good_supplier_relationships": "Maintain good supplier relationships",
      "take_advantage_of_early_payment_discounts": "Take advantage of early payment discounts",
      "flexible_repayment_terms": "Flexible repayment terms",
      "continue": "Continue",
      "select_pomelo_financing_package": "Select CIMB Financing Package",
      "choose_a_financing_package_that_best": "Choose a financing package that best suits your needs",
      "pomelo_your_trusted_financial_partner": "CIMB - Your Trusted Financial Partner",
      "as_a_valued_pomelo_customer_you": "As a valued CIMB customer, you have access to exclusive\n                    financing packages tailored for your business needs.",
      "interest_rate": "Interest Rate",
      "max_term": "Max Term",
      "processing_time": "Processing Time",
      "specify_the_financing_amount_and_terms": "Specify the financing amount and terms",
      "financing_amount_usd": "Financing Amount (MYR) *",
      "attrs": {
        "enter_amount": "Enter amount",
        "any_additional_information": "Any additional information..."
      },
      "maximum": "Maximum: $",
      "requested_term_days": "Requested Term (Days) *",
      "15_days": "15 days",
      "30_days": "30 days",
      "45_days": "45 days",
      "60_days": "60 days",
      "90_days": "90 days",
      "purpose_of_financing": "Purpose of Financing *",
      "select_purpose": "Select purpose",
      "early_payment_discount": "Early Payment Discount",
      "cash_flow_management": "Cash Flow Management",
      "supplier_relationship": "Supplier Relationship",
      "other": "Other",
      "additional_notes": "Additional Notes",
      "review_request": "Review Request",
      "review_financing_request": "Review Financing Request",
      "please_review_your_financing_request_before": "Please review your financing request before submitting",
      "bill_information_2": "BILL INFORMATION",
      "financing_details": "FINANCING DETAILS",
      "bank": "Bank",
      "pomelo": "CIMB",
      "package": "Package",
      "financing_amount": "Financing Amount",
      "term": "Term",
      "days": "days",
      "purpose": "Purpose",
      "additional_notes_2": "ADDITIONAL NOTES",
      "by_submitting_this_request_you_agree": "By submitting this request, you agree to the financing terms\n                  and conditions set by CIMB for the",
      "the_request_will_be_processed_within": ".\n                  The request will be processed within",
      "submit_financing_request": "Submit Financing Request"
    },
    "BillForm": {
      "upload_your_invoice_and_well_extract": "Upload your invoice and we'll extract the details automatically.",
      "drag_drop_your_files_here": "Drag & drop your files here",
      "supported_file_types_pdf_jpg_png": "Supported file types PDF, JPG, PNG",
      "extracting": "Extracting…",
      "extracted": "Extracted",
      "invoice_number_local_id_and_due": "Invoice number, local ID, and due date were extracted from your\n                file. You can edit them below if needed.",
      "attrs": {
        "select_supplier": "Select supplier",
        "autodetected": "Auto-detected"
      },
      "amount_due": "Amount due",
      "currency": "Currency",
      "due_date": "Due date",
      "extracted_details": "Extracted details",
      "invoice_number": "Invoice number",
      "local_id": "Local ID",
      "save": "Save"
    },
    "Bills": {
      "bills": "Bills",
      "upload": "Upload",
      "add_bill": "Add bill",
      "attrs": {
        "search_bills": "Search bills..."
      },
      "show_archived": "Show archived",
      "no_bills_found_matching_your_criteria": "No bills found matching your criteria.",
      "select": "Select",
      "source": "Source",
      "payout": "Payout",
      "requires": "Requires",
      "approvals": "approvals",
      "due_on": "Due on",
      "archive_bill": "Archive bill",
      "approve": "Approve",
      "cancel_payment": "Cancel payment",
      "reassign": "Re-assign",
      "based_on_your_selected_bills": "Based on your selected bills",
      "clear": "Clear",
      "no_selected_bills": "No selected bills",
      "reject": "Reject",
      "cancel_scheduled_payments": "Cancel scheduled payments",
      "schedule_payments": "Schedule payments",
      "what_would_you_like_to_do": "What would you like to do with the rejected",
      "archive_bills": "Archive bills",
      "remove_them_from_the_active_list": "Remove them from the active list permanently.",
      "move_back_to_due": "Move back to Due",
      "return_them_to_the_due_list": "Return them to the due list for reassessment.",
      "confirm_rejection": "Confirm rejection",
      "confirm_approval": "Confirm Approval",
      "are_you_sure_you_want_to": "Are you sure you want to approve",
      "yes_approve": "Yes, approve",
      "cancel_scheduled": "Cancel Scheduled",
      "what_would_you_like_to_do_2": "What would you like to do with the cancelled",
      "return_them_to_the_due_list_2": "Return them to the due list to be scheduled later.",
      "keep_scheduled": "Keep scheduled",
      "confirm_cancellation": "Confirm cancellation",
      "bills_settings": "Bills settings",
      "bill_payments_can_be_approved_by": "Bill payments can be approved by",
      "users_in_these_user_groups_can": "Users in these user groups can approve bills for payment\n                  scheduling. You can also assign specific users from your\n                  company to approve bill payments when they exceed certain\n                  thresholds.",
      "billing_cycles": "Billing cycles",
      "automate_your_payment_runs_by_setting": "Automate your payment runs by setting your payment cycles to\n                  schedule approved payments on these dates. You can select up\n                  to 2 payment run days per month.",
      "number_of_approvals": "Number of approvals",
      "approving_any_payment_for_bills_will": "Approving any payment for bills will require",
      "users_to_approve_except_when_threshold": "user(s) to approve except when threshold\n                  rules apply or a specific user assigned to a bill as\n                  designated approver.",
      "limits_and_thresholds": "Limits and thresholds",
      "add_threshold": "Add threshold",
      "no_specific_threshold_approvers_configured_yet": "No specific threshold approvers configured yet",
      "bills_above": "Bills above",
      "when_threshold_rules_are_configured_payments": "When threshold rules are configured, payments for bills\n                  exceeding these thresholds can only be approved by the\n                  assigned user instead of any number of approvals from the\n                  approver group.",
      "the_default_number_of_staff_members": "The default number of staff members that need to approve each\n                  bill. You can also setup additional specific limits and\n                  thresholds for senior team members.",
      "approver": "Approver",
      "simon_verraest": "Ahmed Saleem",
      "john_smith": "Ibrahim Naseer",
      "sarah_johnson": "Aishath Nazima",
      "this_user_will_need_to_approve": "This user will need to approve bills above this amount",
      "select_a_currency_for_this_threshold": "Select a currency for this threshold",
      "select_a_currency": "Select a currency",
      "eur": "EUR",
      "gbp": "GBP",
      "sgd": "SGD",
      "myr": "MYR",
      "payment_cycles": "Payment cycles"
    },
    "BulkBillUpload": {
      "bulk_upload_bills": "Bulk Upload Bills",
      "upload_a_csv_file_to_add": "Upload a CSV file to add multiple bills at once.",
      "download_template": "Download template",
      "use_this_csv_template_to_format": "Use this CSV template to format your bill data correctly.\n                      Required fields are marked.",
      "download_csv": "Download CSV",
      "or_click_to_browse": "or click to browse",
      "supported_csv": "Supported: .csv",
      "upload_error": "Upload error",
      "expected_fields": "Expected fields",
      "rows_total": "rows total",
      "valid": "valid",
      "with_errors": "with errors",
      "upload_different_file": "Upload different file",
      "total_amount_across": "Total amount across",
      "valid_bills": "valid bills",
      "row": "row",
      "with_validation_errors": "with validation errors",
      "these_rows_have_issues_and_will": "These rows have issues and will not be imported. Fix them in\n                    your file or remove them below.",
      "email": "Email",
      "description": "Description",
      "all_rows_have_been_removed_upload": "All rows have been removed. Upload a different file to try\n                  again.",
      "import": "Import",
      "bills_imported_successfully": "Bills imported successfully",
      "been_added_to_your_account": "been added to your\n                account.",
      "total_usd": "Total: MYR",
      "upload_more": "Upload more",
      "go_to_bills": "Go to Bills"
    }
  }
}
